function validateEmail(email: string) {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
}

function removeEmail(prev: string[], deleteEmail: string) {
  return prev.filter((email) => email !== deleteEmail);
}

function addEmail(emails: string[], newEmail: string) {
  return [...emails, newEmail];
}

export { validateEmail, removeEmail, addEmail };
